<template>
  <div>
    <v-navigation-drawer
      ref="customiseDrawer"
      v-model="value"
      app
      right
      temporary
      class="v-navigation-drawer--width-max"
      stateless
    >
      <div
        class="drawer-container d-flex flex-column justify-space-between black2-color"
      >
        <div
          class="drawer-header d-flex align-center justify-space-between pa-5 pl-6"
        >
          <h3 class="font-28 font-weight-bold">Customise your cover</h3>
        </div>

        <div class="drawer-main flex-grow-1">
          <div class="pt-10 px-6 px-lg-8">
            <h4 class="font-20 mb-3">Cover options</h4>

            <h4 class="font-18 mt-4">Accident and sickness options</h4>
            <BaseLabel
              text="What type of accident and sickness cover do you need?"
              labelClass="mb-1 mt-4 label-text font-16"
            />
            <div class="mb-3">
              <a
                class="font-16 font-weight-600 accent--text text-decoration-underline text-link-hover"
                @click="showModal('DialogContentMPPIQualTypeDisability')"
              >
                More information
              </a>
            </div>
            <BaseSelect
              v-model="localQuestionData.QualTypeDisability.Value"
              vid="QualTypeDisability"
              dataUiid="QualTypeDisability"
              :hideDetails="true"
              :items="qualTypeDisabilityOptions"
              class="mb-10"
              :style="{
                'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
              }"
              :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
              @change="resetQuestionValue('QualPeriodDisability', 'ThirtyDays')"
            />
            <BaseLabel
              text="What accident and sickness qualification period do you need?"
              labelClass="mb-1 label-text font-16"
            />
            <div class="mb-3">
              <a
                class="font-16 font-weight-600 accent--text text-decoration-underline text-link-hover"
                @click="showModal('DialogContentMPPIQualPeriodDisability')"
              >
                More information
              </a>
            </div>

            <BaseRadio
              pslStyle="button"
              v-model="localQuestionData.QualPeriodDisability.Value"
              vid="QualPeriodDisability"
              dataUiid="QualPeriodDisability"
              class="mb-10"
              :hideDetails="true"
              :items="qualPeriodDisabilityOptions"
              :height="$vuetify.breakpoint.lgAndUp ? '56' : '60'"
              :width="$vuetify.breakpoint.smAndDown ? 'calc(50% - 6px)' : '190'"
            />

            <template
              v-if="
                localQuestionData.CoverType.Value ===
                'UnemploymentAndDisability'
              "
            >
              <h4 class="font-18 mt-4">Unemployment options</h4>
              <BaseLabel
                text="What type of unemployment cover do you need?"
                labelClass="mb-1 mt-4 label-text font-16"
              />
              <div class="mb-3">
                <a
                  class="font-16 font-weight-600 accent--text text-decoration-underline text-link-hover"
                  @click="showModal('DialogContentMPPIQualTypeUnemployment')"
                >
                  More information
                </a>
              </div>
              <BaseSelect
                v-model="localQuestionData.QualTypeUnemployment.Value"
                vid="QualTypeUnemployment"
                dataUiid="QualTypeUnemployment"
                :hideDetails="true"
                :items="qualTypeUnemploymentOptions"
                class="mb-10"
                :style="{
                  'max-width': $vuetify.breakpoint.lgAndUp ? '440px' : '100%',
                }"
                :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
                @change="
                  resetQuestionValue('QualPeriodUnemployment', 'ThirtyDays')
                "
              />
              <BaseLabel
                text="What unemployment qualification period do you need?"
                labelClass="mb-1 label-text font-16"
              />
              <div class="mb-3">
                <a
                  class="font-16 font-weight-600 accent--text text-decoration-underline text-link-hover"
                  @click="showModal('DialogContentMPPIQualPeriodUnemployment')"
                >
                  More information
                </a>
              </div>

              <BaseRadio
                pslStyle="button"
                v-model="localQuestionData.QualPeriodUnemployment.Value"
                vid="QualPeriodUnemployment"
                dataUiid="QualPeriodUnemployment"
                class="mb-10"
                :hideDetails="true"
                :items="qualPeriodUnemploymentOptions"
                :height="$vuetify.breakpoint.lgAndUp ? '56' : '60'"
                :width="
                  $vuetify.breakpoint.smAndDown ? 'calc(50% - 6px)' : '190'
                "
              />
            </template>

            <BaseLabel
              text="What benefit period do you need?"
              labelClass="mb-1 label-text font-16"
            />
            <div class="mb-3">
              <a
                class="font-16 font-weight-600 accent--text text-decoration-underline text-link-hover"
                @click="showModal('DialogContentMPPIBenefitPeriod')"
              >
                More information
              </a>
            </div>

            <BaseRadio
              pslStyle="button"
              v-model="localQuestionData.PolicyBenefitPeriod.Value"
              vid="PolicyBenefitPeriod"
              dataUiid="PolicyBenefitPeriod"
              :hideDetails="true"
              class="mb-10"
              :items="policyBenefitPeriodOptions"
              :height="$vuetify.breakpoint.lgAndUp ? '56' : '60'"
              :width="$vuetify.breakpoint.smAndDown ? 'calc(50% - 6px)' : '200'"
            />
          </div>
        </div>

        <div class="drawer-footer d-flex flex-column pa-5 mt-auto">
          <BaseButton
            text="BACK TO QUOTES"
            height="68"
            block
            color="#106175"
            class="font-weight-bold font-20 rounded-pill white--text"
            icon="mdi-chevron-left"
            iconSize="30"
            :loading="isRefreshingCover"
            loadingIconColor="white"
            @click="closeDrawer"
            v-if="!isFormChanged && !isRefreshingCover"
          />
          <template v-else>
            <BaseButton
              text="APPLY CHANGES"
              height="68"
              block
              color="#FAB519"
              text-color="black--text"
              icon-color="black"
              loadingIconColor="black"
              class="font-weight-bold font-20 rounded-pill white--text"
              type="submit"
              icon="mdi-refresh"
              iconSize="30"
              :loading="isRefreshingCover"
              @click="refreshCover"
            />
            <BaseButton
              text="Cancel"
              flat
              link
              depressed
              color="black--text"
              ripple
              small
              class="font-weight-medium px-1 d-flex align-self-center font-18 mt-4"
              @click="closeDrawer()"
            />
          </template>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { QUESTIONS_MODULE, DIALOG_MODULE } from "@/store/types/module-types";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import BaseRadio from "@/components/BaseComponents/BaseRadio.vue";
import BaseSelect from "@/components/BaseComponents/BaseSelect.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";
import { mapState } from "vuex";
import { setItemDataUiids } from "@/constants/component.constants";
import { scrollTop } from "@/common/utils";
import {
  MPPI_POLICY_BENEFIT_PERIOD_OPTIONS,
  MPPI_QUAL_TYPE_OPTIONS,
  MPPI_QUAL_PERIOD_OPTIONS,
} from "@/constants/answer.constants";

export default {
  components: {
    BaseButton,
    BaseSelect,
    BaseLabel,
    BaseRadio,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      isRefreshingCover: false,
      isShowDrawerCustomiseCover: false,
      localQuestionData: {
        CoverType: { Value: "" },
        QualTypeDisability: { Value: "" },
        QualPeriodDisability: { Value: "" },
        PolicyBenefitPeriod: { Value: "" },
        QualPeriodUnemployment: { Value: "" },
        QualTypeUnemployment: { Value: "" },
      },
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["questionMap"]),

    isFormChanged() {
      return (
        this.localQuestionData.QualTypeDisability.Value !==
          this.questionMap.QualTypeDisability.Value ||
        this.localQuestionData.QualPeriodDisability.Value !==
          this.questionMap.QualPeriodDisability.Value ||
        this.localQuestionData.PolicyBenefitPeriod.Value !==
          this.questionMap.PolicyBenefitPeriod.Value ||
        this.localQuestionData.QualTypeUnemployment.Value !==
          this.questionMap.QualTypeUnemployment.Value ||
        this.localQuestionData.QualPeriodUnemployment.Value !==
          this.questionMap.QualPeriodUnemployment.Value
      );
    },
    qualTypeDisabilityOptions() {
      return setItemDataUiids("QualTypeDisability", MPPI_QUAL_TYPE_OPTIONS);
    },
    qualPeriodDisabilityOptions() {
      const options =
        this.localQuestionData.QualTypeDisability.Value === "DayOne"
          ? MPPI_QUAL_PERIOD_OPTIONS.filter(
              (i) => i.value !== "OneHundredEightyDays"
            )
          : MPPI_QUAL_PERIOD_OPTIONS;

      return setItemDataUiids("QualPeriodDisability", options);
    },
    qualTypeUnemploymentOptions() {
      return setItemDataUiids("QualTypeUnemployment", MPPI_QUAL_TYPE_OPTIONS);
    },
    qualPeriodUnemploymentOptions() {
      const options =
        this.localQuestionData.QualTypeUnemployment.Value === "DayOne"
          ? MPPI_QUAL_PERIOD_OPTIONS.filter(
              (i) => i.value !== "OneHundredEightyDays"
            )
          : MPPI_QUAL_PERIOD_OPTIONS;

      return setItemDataUiids("QualPeriodUnemployment", options);
    },
    policyBenefitPeriodOptions() {
      return setItemDataUiids(
        "PolicyBenefitPeriod",
        MPPI_POLICY_BENEFIT_PERIOD_OPTIONS
      );
    },
  },
  watch: {
    questionMap: {
      handler(newMap) {
        this.setupLocalQuestionData(newMap);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, ["getQuotes"]),
    ...mapMutations(DIALOG_MODULE, ["showModal"]),

    refreshCover() {
      if (this.isRefreshingCover) return;
      this.isRefreshingCover = true;
      const quoteRequestFields = {
        IsPartialQuote: false,
      };

      this.questionMap.QualTypeDisability.Value =
        this.localQuestionData.QualTypeDisability.Value;
      this.questionMap.QualPeriodDisability.Value =
        this.localQuestionData.QualPeriodDisability.Value;
      this.questionMap.PolicyBenefitPeriod.Value =
        this.localQuestionData.PolicyBenefitPeriod.Value;
      this.questionMap.QualPeriodUnemployment.Value =
        this.localQuestionData.QualPeriodUnemployment.Value;
      this.questionMap.QualTypeUnemployment.Value =
        this.localQuestionData.QualTypeUnemployment.Value;

      this.getQuotes(quoteRequestFields)
        .then(() => {
          this.isRefreshingCover = false;
          this.closeDrawer();
          scrollTop();
        })
        .catch(() => {
          this.isRefreshingCover = false;
        });
    },
    setupLocalQuestionData(data) {
      this.localQuestionData = {
        CoverType: { ...data.CoverType },
        QualTypeDisability: { ...data.QualTypeDisability },
        QualPeriodDisability: { ...data.QualPeriodDisability },
        PolicyBenefitPeriod: { ...data.PolicyBenefitPeriod },
        QualPeriodUnemployment: { ...data.QualPeriodUnemployment },
        QualTypeUnemployment: { ...data.QualTypeUnemployment },
      };
    },
    closeDrawer() {
      this.$emit("closeDrawer");
      this.setupLocalQuestionData(this.questionMap);
    },
    resetQuestionValue(key, value = "") {
      if (!this.localQuestionData[key]) return;
      this.localQuestionData[key].Value = value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/AppComponents/_DrawerCustomizeCover.scss";
</style>
